<!--------- Header area start --------->
<header class="gm-header">
	<div class="container">
		<div class="gm-header__inner">
			<div class="gm-header__brand">
				<a class="gm-logo" routerLink="/" aria-label="Gigmor">
					<img src="assets/img/logo.svg" alt="Gigmor" />
				</a>
				<span class="gm-header__partner" *ngIf="partnerLabel">{{ partnerLabel }}</span>
			</div>
			<nav class="gm-header__actions">
				<a class="gm-login" [class.gm-login--hide-mobile]="hideLoginOnMobile" (click)="openArtist(null)">Log In</a>
				<a class="gm-signup-pill" (click)="openArtist(null)">Sign Up</a>
			</nav>
		</div>
	</div>
</header>
<!--------- Header area end --------->

<!--------- Mobile app popup start --------->
<div *ngIf="showPopup">
	<div class="overlay"></div>
	<div class="center-popup">
		<!-- <button type="button" class="popup-back" (click)="showPopup = false" aria-label="Back">
			<img src="assets/img/back-button.svg" alt="" />
			<span>Back</span>
		</button> -->
		<div class="phone-device ios" [ngClass]="getDynamicClass()">
			<figure style="margin: 0 auto"><iframe scrolling="no" importance="high" allow="payment" [src]="iframeURL | safe : 'resourceUrl'"></iframe></figure>
		</div>
	</div>
</div>
<!--------- Mobile app popup end --------->
